module.exports = __webpack_public_path__ + "img/white-flame.83f2209d.svg";